var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.isMobile || _vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('activity-wrapper', {
    staticClass: "drag-and-drop-fractions",
    attrs: {
      "slot": "content",
      "id": !_vm.shouldShowKeyboard ? "drag-and-drop-fractions" : "drag-and-drop-fractions-with-keyboard"
    },
    slot: "content"
  }, [!_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "questionSection"
    }
  }, [_vm.currentRound.dynamicContent ? _c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.dynamicContent
    }
  }) : _vm._e()], 1) : _vm._e(), !_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "dragAndDropSection"
    }
  }, [_c('div', {
    staticClass: "draggableArea"
  }, [_c('div', {
    staticClass: "draggableBankArea"
  }, _vm._l(_vm.currentRound.draggableItems, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "bankAreaItem focusable",
      attrs: {
        "aria-label": ("Answer = " + (item.label)),
        "data-id": item.id,
        "role": "button",
        "tabindex": "10"
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDraggableItemEnterEvent(item.id);
        }
      }
    }, _vm._l(_vm.arrayOfDropZoneLength, function (x, index) {
      return _c('div', {
        key: x,
        staticClass: "numbers"
      }, [_c('div', {
        class: ("startingPoint startingPoint-" + (item.id))
      }), _c('div', {
        class: "dragAndDropContent dragContent draggableItem",
        style: {
          backgroundColor: ((_vm.getDragContentBackground(item, index)) + " !important")
        },
        attrs: {
          "id": ("draggable-" + (item.id) + "-" + x)
        }
      }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])]);
    }), 0);
  }), 0)]), _c('div', {
    staticClass: "droppableArea"
  }, [_c('div', {
    staticClass: "droppableAreaTop"
  }, _vm._l(_vm.currentRound.dropZones, function (item, index) {
    var _vm$getAssociatedHint;
    return _c('div', {
      key: ("top" + (item.id)),
      staticClass: "dropItemContainer top"
    }, [item.titleHtml ? _c('div', {
      staticClass: "titleText"
    }, [_c('html-renderer', {
      attrs: {
        "htmlObject": item.titleHtml
      }
    })], 1) : _vm._e(), !(index % 2) ? _c('div', {
      class: ("droppableItem " + (_vm.getDroppableItemClass()) + " focusable"),
      style: {
        backgroundColor: ((_vm.getDroppableBackground(item)) + " !important")
      },
      attrs: {
        "aria-label": _vm.getFractionAriaLabel(("dropArea-" + (item.id)), 'Numerator', index),
        "id": ("dropArea-" + (item.id)),
        "role": "figure",
        "tabindex": "-1"
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDroppableItemEnterEvent(("dropArea-" + (item.id)));
        }
      }
    }, [_vm.isGuessedCorrectly(item) && !_vm.shouldShowKeyboard && _vm.isSubmitted ? _c('CorrectIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.isGuessedIncorrectly(item) && !_vm.shouldShowKeyboard ? _c('WrongIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.showCorrectAnswers && !_vm.isGuessedCorrectly(item) && !_vm.isSubmitted ? _c('div', {
      staticClass: "dragAndDropContent correctAnswerContent"
    }, [_vm._v("\n                  " + _vm._s((_vm$getAssociatedHint = _vm.getAssociatedHintItem(item.correctItemIds, ("The correct numerator for fraction " + (index ? index : index + 1) + " is %."))) === null || _vm$getAssociatedHint === void 0 ? void 0 : _vm$getAssociatedHint.label) + "\n                ")]) : _vm._e()], 1) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "droppableAreaBottom"
  }, _vm._l(_vm.currentRound.dropZones, function (item, index) {
    var _vm$getAssociatedHint2;
    return _c('div', {
      key: ("bottom" + (item.id)),
      staticClass: "dropItemContainer bottom"
    }, [index % 2 ? _c('div', {
      staticClass: "fractionLine"
    }) : _vm._e(), index % 2 ? _c('div', {
      class: ("droppableItem " + (_vm.getDroppableItemClass()) + " focusable"),
      style: {
        backgroundColor: ((_vm.getDroppableBackground(item)) + " !important")
      },
      attrs: {
        "aria-label": _vm.getFractionAriaLabel(("dropArea-" + (item.id)), 'Denominator', index),
        "id": ("dropArea-" + (item.id)),
        "role": "figure",
        "tabindex": "-1"
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDroppableItemEnterEvent(("dropArea-" + (item.id)));
        }
      }
    }, [_vm.isGuessedCorrectly(item) && !_vm.shouldShowKeyboard && _vm.isSubmitted ? _c('CorrectIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.isGuessedIncorrectly(item) && !_vm.shouldShowKeyboard ? _c('WrongIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.showCorrectAnswers && !_vm.isGuessedCorrectly(item) && !_vm.isSubmitted ? _c('div', {
      staticClass: "dragAndDropContent correctAnswerContent"
    }, [_vm._v("\n                  " + _vm._s((_vm$getAssociatedHint2 = _vm.getAssociatedHintItem(item.correctItemIds, ("The correct denominator for fraction " + (index > 1 ? index - 1 : index) + " is %."))) === null || _vm$getAssociatedHint2 === void 0 ? void 0 : _vm$getAssociatedHint2.label) + "\n                ")]) : _vm._e()], 1) : _vm._e()]);
  }), 0)])]) : _vm._e(), _vm.shouldShowKeyboard ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e()])], 2), _c('article', {
    style: {
      display: _vm.keyboardEnabled ? 'block' : 'none'
    }
  }, [_vm._t("keyboard")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }